import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { ToggleColorModeButton } from 'src/features/theme/index';
import ResponsiveAppMenu from './components/responsive-app-menu';
import LanguageMenu from './components/language-menu';
import UserMenu from './components/user-menu';

function Topbar() {
    return (
        <AppBar position="static">
            <Container maxWidth={false}>
                <Toolbar disableGutters>
                    <ResponsiveAppMenu />
                    <ToggleColorModeButton sx={{ mr: 1 }} />
                    <LanguageMenu />
                    <UserMenu />
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Topbar;
